export default [
  {
    path: '/riseOrderEasilyList', name: 'riseOrderEasilyList', component: () => import('@/pages/activity/riseOrderEasily/riseOrderEasilyList'), meta: { title: '升单易' },
  },
  {
    path: '/addRiseOrderEasily', name: 'addRiseOrderEasily', component: () => import('@/pages/activity/riseOrderEasily/addRiseOrderEasily'), meta: { title: '升单易' },
  },
  {
    path: '/riseOrderEasilyDetail', name: 'riseOrderEasilyDetail', component: () => import('@/pages/activity/riseOrderEasily/riseOrderEasilyDetail'), meta: { title: '升单易' },
  },
  {
    path: '/riseOrderEasilyIntroduce', name: 'riseOrderEasilyIntroduce', component: () => import('@/pages/activity/riseOrderEasily/riseOrderEasilyIntroduce'), meta: { title: '升单易' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/riseOrderEasily.js